export default __webpack_public_path__ + "35e11c3e4c4e8511601078954e41c10c.gif";